import React from 'react'
import EmptyPlaceholder from '../EmptyPlaceholder'

const GridSquare = ({ title, contents }) => (
  <div>
    {title}
    <h4>
      <EmptyPlaceholder>{contents}</EmptyPlaceholder>
    </h4>
  </div>
)
export default GridSquare
